import consola from 'consola';

const defaults = {
  label: 'NO-LABEL',
  deployment: 'NO-DEPLOYMENT',
  service: 'NO-SERVICE',
};
class ConsoleLogReporter {
  constructor(metadata) {
    this.metadata = { ...defaults, ...metadata };
  }

  log(logObj) {
    // console.log(logObj);
    consola[logObj.type === 'log' ? 'info' : logObj.type](
      logObj.date.toISOString(),
      `[${this.metadata.label}]`,
      ...logObj.args,
    );
  }
}

export default ConsoleLogReporter;
